import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TopSection } from './TopSection';
import { Payment } from '@apply/api/src/api/PaymentApi';
import { TimelineSection } from './TimelineSection';
import { PaymentDetailsSection } from './PaymentDetails';
import { PaymentMethodSection } from './PaymentMethodSection';

export interface IPayeeFormModalParameters {
    payment: Payment | undefined;
    set_editModalPayment: React.Dispatch<React.SetStateAction<Payment | undefined>>;
    set_refundModalPayment: React.Dispatch<React.SetStateAction<Payment | undefined>>;
    save_bfiNumber: (paymentId: number, bfiNumber: string) => void;
}

export const PayeeEditModal = ({
    payment,
    set_editModalPayment,
    set_refundModalPayment,
    save_bfiNumber,
}: IPayeeFormModalParameters): React.ReactElement => {
    if (payment === undefined) return <></>;

    const [bfiNumber, set_bfiNumber] = useState<string>(payment.bfiNumber);

    return (
        <div
            className='modal-dialog'
            role='document'
        >
            <Dialog
                open={true}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <div
                    className='page-header'
                    role='banner'
                >
                    <h1>View Payment</h1>
                </div>
                <DialogContent className='payment-edit'>
                    <TopSection
                        payment={payment}
                        set_refundModalPayment={set_refundModalPayment}
                        bfiNumber={bfiNumber}
                        set_bfiNumber={set_bfiNumber}
                    />
                    <TimelineSection payment={payment} />
                    <PaymentDetailsSection payment={payment} />
                    <PaymentMethodSection payment={payment} />
                </DialogContent>
                <DialogActions>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button primary'
                        onClick={() => save_bfiNumber(payment.paymentId, bfiNumber)}
                    >
                        Save
                    </button>
                    <button
                        style={{ padding: 6, marginRight: 20 }}
                        type='button'
                        className='button hollow'
                        onClick={() => set_editModalPayment(undefined)}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
